import { styled, Icon } from '@mui/material';

export const MobileAppHeader = () => {
  const handleBack = () => {
    globalThis.history.back();
  };

  return (
    <Header>
      <MobileBackButton
        onClick={handleBack}
        aria-label='Go back'
      >
        <Icon>arrow_back</Icon>
      </MobileBackButton>
    </Header>
  );
};

const Header = styled('header')`
  display: flex;
  align-items: center;
  height: var(--app-header-height);
  z-index: 10;
  background-color: var(--mui-palette-background-main);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
`;

const MobileBackButton = styled('button')`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 50px;
  height: 50px;

  background: none;
  border: none;
  padding: 0;
  color: inherit;

  -webkit-tap-highlight-color: transparent;

  &:active {
    opacity: 0.6;
  }
`;
